import { useEffect } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../../features/table/helpers';
import { defaultViewStyle, viewStyleKey, withArchiveKey } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useLeadStore } from '../../../../../store/use-lead-store';
import { SortType } from '../../../../../types/props';

export const useLeads = () => {
  const { list, fetchLeads, restoreLead, deleteLead } = useLeadStore();
  const { t } = useLang();

  const params = useQueryParams().getQueryParams();
  const ts = params['ts'];
  const name = params.name;
  const phone = params.phone;
  const email = params.email;
  const sex = params.sex;
  const age = params.age;
  const rating = params.rating;
  const source = params.source;
  const with_archive = !!params[withArchiveKey];
  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  useEffect(() => {
    fetchLeads({
      name,
      phone,
      email,
      sex,
      age,
      rating,
      source,

      field: sortField,
      dir: sortDirection,

      n: 1000,
      is_by_company: true,
      since_id: 0,
      with_archive,
    });
  }, [age, email, name, phone, rating, sex, sortDirection, sortField, source, ts, with_archive]);

  return {
    t,
    restoreLead,
    deleteLead,
    viewStyle,
    list,
  };
};
